import { useNavigate } from "react-router-dom";
import "../../../styles/StudentAbsence.css";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import { useAuth } from "../../../context/AuthContext";
import LoadingScreen from "../../../components/LoadingScreen";
import DenyAccessPage from "../../../components/DenyAccessPage";
import Popup from "../../../components/Popup";
import Selector2 from "../../../components/Selector2";
import { fetchWisdomRelatedEmployees, fetchWisdomRelatedSchools } from "services/wisdom/wisdomData";
import WisdomNavbar from "components/navbars/WisdomNabvar";
import { sendEmployeeAbsence } from "services/wisdom/wisdomPms";

const absenceCause = [
    "إجازة عارضة",
    "إجازة مرضية",
    "إجازة اعتيادية",
    "إجازة بدون أجر",
    "مأمورية عمل",
    "إجازة وضع / رعاية طفل",
    "إجازة زواج",
    "إجازة حج / عمرة",
    "إجازة رسمية",
    "إيقاف عن العمل",
    "غياب بدون إذن"
];

function WisdomEmployeeAbsence() {
    const navigate = useNavigate();
    const { userInfo } = useAuth();
    const { language } = useLanguage();
    const [submitted, setSubmitted] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [cause, setCause] = useState("");
    const [absenceDate, setAbsenceDate] = useState("");
    const [schools, setSchools] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [filteredEmployee, setFilteredEmployee] = useState(null);
    const [selectedSchool, setSelectedSchool] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // fetching required data
    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                const employeeResponse = await fetchWisdomRelatedEmployees();
                if (userInfo.user_role === "Operations Excellence Lead" || userInfo.user_role === "Super Admin") {
                    const schoolResponse = await fetchWisdomRelatedSchools();
                    setSchools(schoolResponse);
                    setEmployees(employeeResponse);
                } else {
                    const filterEmployees = employeeResponse.filter(emp => emp.employee?.organization_id === Number(userInfo?.organization_id));
                    setEmployees(filterEmployees);
                }
            } catch (err) {
                console.error("API Error:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [userInfo]);

    const submitEmployeeAbsence = async (e) => {
        e.preventDefault();

        const data = {
            employee_id: Number(selectedEmployee),
            cause,
            absence_date: absenceDate
        };

        try {
            await sendEmployeeAbsence(data);
            toast.success(language ? "Absence has been submitted" : "تم تسجيل الغياب");
            setSubmitted(true);
        } catch (err) {
            toast.error("please fill all data required");
        }
    };

    // why ?
    useEffect(() => {
        const getEmployee = () => {
            const employee = employees.find(emp => emp.employee.id === Number(selectedEmployee));
            setFilteredEmployee(employee)
        }

        getEmployee();
    }, [selectedEmployee, employees])

    useEffect(() => {
        const filterEmployees = () => {
            const filteringEmployees = employees.filter(t => (userInfo.user_role !== "Operations Excellence Lead" && userInfo.user_role !== "Super Admin") ? t.employee?.organization_id === Number(userInfo?.organization_id) : t.employee?.organization_id === Number(selectedSchool));
            setFilteredEmployees(filteringEmployees);
        }
        filterEmployees();
    }, [selectedSchool, employees, userInfo]);

    const closePopup = () => {
        setSubmitted(false)
        navigate('/pms');
    };


    if (loading) return <LoadingScreen />;
    if (error) return <p>Error: {error.message}</p>;
    if (userInfo.user_role !== "Operations Excellence Lead" && userInfo.user_role !== "Super Admin" && userInfo.user_role !== "Supervisor" && userInfo.user_role !== "Social Worker") return <DenyAccessPage homePage='/pms' />;

    return (
        <div className="bg-formColor flex justify-center flex-wrap min-h-screen">
            <WisdomNavbar />
            <h1 className="w-full text-2xl font-bold text-center mt-6 mb-4">
                {language ? "Employee Absence" : "غياب الموظفيين"}
            </h1>
            <div className="w-full flex flex-wrap justify-center gap-4 px-4 mb-4" dir={language ? "ltr" : "rtl"}>
                {(userInfo.user_role === "Operations Excellence Lead" || userInfo.user_role === "Super Admin") ? <Selector2
                    label="school"
                    title={language ? "School:" : "مدرسة:"}
                    description={language ? "Please Select a school" : "الرجاء اختيار مدرسة"}
                    data={schools}
                    value={selectedSchool}
                    onChange={(e) => setSelectedSchool(e.target.value)}
                    name="name"
                    extraCSS="w-[99%]"
                    All={false}
                /> : null}
                <Selector2
                    label="employees"
                    title={language ? "Employees:" : "الموظفيين:"}
                    description={language ? "Please Select an Employee" : "الرجاء اختيار موظف"}
                    data={filteredEmployees}
                    value={selectedEmployee || ""}
                    onChange={(e) => setSelectedEmployee(e.target.value)}
                    name="user"
                    optionValue="employee"
                    extraCSS="w-[99%]"
                    All={false}
                />
            </div>
            {filteredEmployee?.employee ? (
                <form className="teacherSessions" dir={language ? "ltr" : "rtl"} onSubmit={submitEmployeeAbsence}>
                    <div className="flex md:flex-row flex-col md:gap-0 gap-2 justify-evenly items-center m-2.5" key={filteredEmployee.id}>
                        <div className="md:min-w-[200px] min-w-full text-center m-2.5 flex flex-col gap-2">
                            <div className="font-bold text-center">{language ? "Name:" : ":الاسم"}</div>
                            <div className="">
                                {filteredEmployee?.employee?.first_name} {filteredEmployee?.employee?.middle_name} {filteredEmployee?.employee?.last_name}
                            </div>
                        </div>
                        <div className="md:min-w-[200px] min-w-full text-center m-2.5 flex flex-col gap-2">
                            <div className="font-bold text-center">
                                {language ? "Status:" : ":الحالة"}
                            </div>
                            <select
                                id={`absenceStatus-${filteredEmployee.id}`}
                                name={`absenceStatus-${filteredEmployee.id}`}
                                className="w-full py-2.5 px-3 border border-[#ccc] rounded-lg text-sm outline-none transition-[border-color] duration-200 focus:border-[#007bff] focus:shadow-[0_0_0_2px_rgba(0,123,255,0.1)]"
                                value={cause}
                                onChange={(e) => setCause(e.target.value)}
                            >
                                <option value="" disabled>
                                    {language ? "Select a reason" : "اختار السبب"}
                                </option>
                                {absenceCause.map(cause =>
                                    <option key={cause} value={cause}>{cause}</option>
                                )}
                            </select>
                        </div>
                        <div className="md:min-w-[200px] min-w-full text-center m-2.5 flex flex-col gap-2">
                            <div className="font-bold text-center">
                                {language ? "Absence Date:" : "تاريخ الغياب:"}
                            </div>
                            <input
                                id={`reasonInput-${filteredEmployee.id}`}
                                name={`reason-${filteredEmployee.id}`}
                                type="date"
                                className="w-full py-2.5 px-3 border border-[#ccc] rounded-lg text-sm outline-none transition-[border-color] duration-200 focus:border-[#007bff] focus:shadow-[0_0_0_2px_rgba(0,123,255,0.1)]"
                                value={absenceDate}
                                onChange={(e) => setAbsenceDate(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="flex justify-center items-center w-full">
                        <button className="bg-wisdomOrange hover:bg-wisdomDarkOrange text-white rounded p-2 flex self-center items-center">
                            {language ? "Submit" : "ارسال"}
                        </button>
                    </div>
                </form>
            ) : (
                <div className="noTeacher">
                    {language ? "No Data Available" : "لا يوجد بيانات حاليا"}
                </div>
            )}
            <Popup
                isOpen={submitted}
                onClose={closePopup}
                message={language ? "Absence has been submitted successfully" : "تم تسجيل الغياب بنجاح"}
            />
        </div>
    );
}

export default WisdomEmployeeAbsence;